// extracted by mini-css-extract-plugin
export default {"viewBtn":"PrintLink_viewBtn__iAccz","spin":"PrintLink_spin__MDRox"};